import { Badge, type Tone } from '@/components/ui/Badge';
import { daysUntil, formatDate } from '@/lib/format';

/**
 * Срок на документ. Прагът по подразбиране е 30 дни, но за картата за тахограф
 * е 60 — издаването от ИААА отнема около месец, така че предупреждение на
 * седмия ден е безполезно.
 */
export function ExpiryBadge({
  date,
  warnDays = 30,
  label,
}: {
  date: string | null | undefined;
  warnDays?: number;
  label?: string;
}) {
  if (!date) {
    return (
      <Badge tone="neutral" title={label}>
        липсва
      </Badge>
    );
  }

  const days = daysUntil(date);
  if (days === null) return <Badge tone="neutral">—</Badge>;

  const tone: Tone = days < 0 ? 'danger' : days <= warnDays ? 'warn' : 'neutral';
  const suffix = days < 0 ? `изтекъл преди ${Math.abs(days)} дн` : `след ${days} дн`;

  return (
    <Badge tone={tone} title={`${label ? `${label}: ` : ''}${formatDate(date)} (${suffix})`}>
      {formatDate(date)}
    </Badge>
  );
}
